import React, { useEffect, useState, useRef } from 'react';
import useApi from '../../api/useApi';
import moment from 'moment';

const dataSetProps = {
  label: '',
  backgroundColor: 'transparent',
  borderCapStyle: 'butt',
  borderColor: '#00CCFF',
  borderDashOffset: 0.0,
  borderJoinStyle: 'miter',
  pointBorderColor: 'rgba(75,192,192,1)',
  pointBackgroundColor: '#fff',
  pointBorderWidth: 2,
  pointHoverRadius: 5,
  pointHoverBackgroundColor: 'rgba(75,192,192,1)',
  pointHoverBorderColor: 'rgba(220,220,220,1)',
  pointHoverBorderWidth: 2,
  pointRadius: 3,
  pointHitRadius: 0,
};

const chartOptions = {
  animation: {
    duration: 0,
  },
  maintainAspectRatio: false,
  response: true,
  events: [],
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
      labels: {
        padding: 100,
      },
    },
  },

  legend: {
    display: false,
    labels: {
      padding: 100,
    },
  },
  scales: {
    xAxes: [
      {
        ticks: {
          display: true,
          tickWidth: '5px',
          padding: 10,
        },
        gridLines: {
          display: true,
          drawBorder: true,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          display: true,
          tickWidth: '5px',
          padding: 10,
        },
        gridLines: {
          display: true,
          drawBorder: true,
        },
      },
    ],
  },
};

function CumulativeInventory({ handleClose }) {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = JSON.parse(sessionStorage.user)?.organization?.id;

  const myChart1 = useRef();
  const myChart2 = useRef();
  const myChart3 = useRef();

  const [inventoryData, setInventoryData] = useState();
  const [loaderId, setLoaderForId] = useState('');
  const [lastDateData, setlastDateData] = useState({
    date: '',
    devicesIn: 0,
    devicesOut: 0,
    deviceCount: 0,
  });

  const [inventoryRes, getInventory] = useApi();
  const [reportRes, getReport] = useApi();

  useEffect(() => {
    getInventory(`/organization/${orgId}/inventory?days=7`, 'GET');
  }, []);

  useEffect(() => {
    if (!inventoryRes.isLoading && !inventoryRes.isError && inventoryRes.data) {
      setInventoryData(inventoryRes.data);
    }
  }, [inventoryRes.isLoading, inventoryRes.isError, inventoryRes.data]);

  useEffect(() => {
    if (inventoryData) {
      const ctx = myChart1.current;

      if (!ctx) return;

      let dates_rev = Object.keys(inventoryData?.dailyCount).reverse();

      let dates = dates_rev.map((x) => moment(+x).format('DD/MM/YYYY'));

      setlastDateData({
        date: moment(+dates_rev[dates_rev.length - 1]).format('DD/MM/YYYY'),
        devicesIn: inventoryData?.dailyCount[+dates_rev[dates_rev.length - 1]].inCount,
        devicesOut: inventoryData?.dailyCount[+dates_rev[dates_rev.length - 1]].outCount,
        deviceCount: inventoryData?.dailyCount[+dates_rev[dates_rev.length - 1]].deviceCount,
      });

      new Chart(ctx, {
        type: 'line',
        data: {
          labels: dates,
          datasets: [
            {
              ...dataSetProps,
              data: Object.values(inventoryData?.dailyCount)
                .reverse()
                .map((x) => x.inCount),
            },
          ],
        },
        options: {
          ...chartOptions,
          title: {
            display: true,
            text: 'Total Devices In',
          },
        },
      });

      const ctx2 = myChart2.current;
      if (!ctx2) return;
      new Chart(ctx2, {
        type: 'line',
        data: {
          labels: dates,
          datasets: [
            {
              ...dataSetProps,
              data: Object.values(inventoryData?.dailyCount)
                .reverse()
                .map((x) => x.outCount),
            },
          ],
        },
        options: {
          ...chartOptions,
          title: {
            display: true,
            text: 'Total Devices Out',
          },
        },
      });

      const ctx3 = myChart3.current;
      if (!ctx3) return;
      new Chart(ctx3, {
        type: 'line',
        data: {
          labels: dates,
          datasets: [
            {
              ...dataSetProps,
              data: Object.values(inventoryData?.dailyCount)
                .reverse()
                .map((x) => x.deviceCount),
            },
          ],
        },
        options: {
          ...chartOptions,
          title: {
            display: true,
            text: 'Total Devices',
          },
        },
      });
    }
  }, [inventoryData]);

  const getReportData = (date, warehouseId, zoneId) => {
    const date1 = new Date(date);
    const date2 = new Date();
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    // console.log(date2, date1, diffDays);
    getReport(`/organization/${orgId}/inventory/report?day=${diffDays}&warehouse=${warehouseId}&zone=${zoneId}`, 'GET');
  };

  useEffect(() => {
    if (!reportRes.isLoading && !reportRes.isError && reportRes.data) {
      downloadReport(reportRes.data);
    }
  }, [reportRes.isLoading, reportRes.isError, reportRes.data]);

  const downloadReport = ({ report }) => {
    if (report) {
      const rows = [];
      const headerRows = ['TIMESTAMP', 'DEVICE', 'GATEWAY', 'ZONE', 'WAREHOUSE', 'DIRECTION'];
      rows.push(headerRows);

      report.warehouses.forEach((warehouse) => {
        warehouse.zones.forEach((zone) => {
          zone.data.forEach((dataOut) => {
            const column0 = dataOut?.timestamp;
            const column1 = dataOut?.deviceId;
            const column2 = dataOut?.blegwId;
            const column3 = zone?.id;
            const column4 = warehouse?.id;
            const column5 = 'PRESENT';

            /* add a new records in the array */
            rows.push([column0, column1, column2, column3, column4, column5]);
          });

          zone.dataIn.forEach((dataIn) => {
            const column0 = dataIn?.timestamp;
            const column1 = dataIn?.deviceId;
            const column2 = dataIn?.blegwId;
            const column3 = zone?.id;
            const column4 = warehouse?.id;
            const column5 = 'IN';

            /* add a new records in the array */
            rows.push([column0, column1, column2, column3, column4, column5]);
          });

          zone.dataOut.forEach((dataOut) => {
            const column0 = dataOut?.timestamp;
            const column1 = dataOut?.deviceId;
            const column2 = dataOut?.blegwId;
            const column3 = zone?.id;
            const column4 = warehouse?.id;
            const column5 = 'OUT';

            /* add a new records in the array */
            rows.push([column0, column1, column2, column3, column4, column5]);
          });
        });
      });

      let csvContent = 'data:text/csv;charset=utf-8,';

      /* add the column delimiter as comma(,) and each row splitted by new line character (\n) */
      rows.forEach(function (rowArray) {
        const row = rowArray.join(',');
        csvContent += `${row}\r\n`;
      });
      /* create a hidden <a> DOM node and set its download attribute */
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'inventory.csv');
      document.body.appendChild(link);
      /* download the data file  */
      link.click();

      setLoaderForId('');
    }
  };

  return (
    <div
      className="flex-col mx-auto"
      style={{
        width: '78%',
      }}
    >
      <div
        className="mt-10 h-full bg-white mx-auto overflow-hidden phone_font dash_ui relative px-3"
        style={{
          width: '100%',
          height: '51vh',
        }}
      >
        <div className="">
          <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
            <div
              className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
              style={{ paddingTop: '4vh' }}
            >
              <span className="text-titleColor font-bold text-base">Inventory</span>

              <div className="flex gap-x-6 font-bold text-gray-600 text-xs">
                <span>{lastDateData.date}</span>
                <span>{`Total Devices: ${lastDateData?.deviceCount}`}</span>
                <span>{`Total Devices In: ${lastDateData?.devicesIn}`}</span>
                <span>{`Total Devices out: ${lastDateData?.devicesOut}`}</span>
              </div>

              <button
                className={`mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1  rounded-md text-xs font-bold focus:outline-none flex justify-center items-center h-7 mobile_dash bg-btnBg text-white button_text `}
                onClick={handleClose}
              >
                Back
              </button>
            </div>
          </div>
        </div>

        <div className="tbl tbl1 mobile_view" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-3">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center">
                <div className=" py-2.5 text-xs font-bold w-1/12 uppercase">Date</div>
                <div className=" py-2.5 px-2 text-xs font-bold w-3/12 uppercase">Warehouse</div>
                <div className=" py-2.5 text-xs font-bold w-2/12 uppercase">Zone</div>
                <div className=" py-2.5 text-xs font-bold w-2/12 uppercase text-center">Inventory Count</div>
                <div className=" py-2.5 text-xs font-bold w-2/12 uppercase text-center">Device In Count</div>
                <div className=" py-2.5 text-xs font-bold w-2/12 uppercase text-center">Device Out Count</div>
                <div className=" py-2.5 text-xs font-bold w-2/12 uppercase text-center">Report</div>
              </div>
            </div>
            {!inventoryRes.isLoading ? (
              <div className="hideScroll device_scroll" style={{ overflowY: 'auto', height: '30vh' }}>
                <div className="w-full">
                  {inventoryData &&
                    inventoryData?.inventory &&
                    inventoryData?.inventory.length !== 0 &&
                    inventoryData.inventory.map((x) => {
                      return (
                        <div
                          className={`my-2 px-8 py-1 xl:py-1.5 items-center flex
                   relative hover:border-indigo-200 focus-within:border-indigo-200 `}
                          style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                          key={x.id}
                        >
                          <div className="w-1/12 flex items-center text-role text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs phone_font">
                            {moment(x?.date).format('DD-MM-YYYY')}
                          </div>
                          <div className="py-2.5 px-2 text-left text-xs w-3/12">{x?.Warehouse?.name}</div>
                          <div className="py-1 text-left text-xs w-2/12">{x?.Zone?.name}</div>
                          <div className="py-1 text-center text-xs w-2/12">{x?.deviceCount}</div>
                          <div className="py-1 text-center text-xs w-2/12">{x?.deviceInCount}</div>
                          <div className="py-1 text-center text-xs w-2/12">{x?.deviceOutCount}</div>
                          <div
                            className="w-2/12 flex justify-center cursor-pointer text-left "
                            onClick={() => {
                              getReportData(x.date, x.warehouseId, x.zoneId);
                              setLoaderForId(x.id);
                            }}
                          >
                            {loaderId === x.id ? (
                              <img src="assets/img/loader.svg" className="w-9 mx-auto" alt="" />
                            ) : (
                              <img src="assets/img/Report_Download.svg" className="h-4" alt="" />
                            )}
                          </div>
                        </div>
                      );
                    })}
                  <div />
                </div>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>

      <div
        className="mt-4 h-full w-full bg-white mx-auto overflow-hidden phone_font dash_ui relative flex flex gap-x-6 p-6"
        style={{
          height: '38vh',
        }}
      >
        <div className="w-1/3 h-60">
          <canvas ref={myChart3} height={50} />
        </div>
        <div className="w-1/3 h-60">
          <canvas ref={myChart1} height={50} />
        </div>
        <div className="w-1/3 h-60">
          <canvas ref={myChart2} height={50} />
        </div>
      </div>
    </div>
  );
}

export default CumulativeInventory;
